import React, { useEffect, useRef, useState, useMemo } from 'react'

import clsx from 'clsx'

import Breadcrumb from 'components/Breadcrumb'
import { Container } from 'components/Grid'
import { useAppContext } from 'context/AppContext'

import classes from './BreadcrumbBar.module.scss'

const FADE_TRIGGER = 16

/** @type {import('./types').default} */
const BreadcrumbBar = ({ breadcrumbs = [] }) => {
  const scrollRef = useRef()
  const [showFadeLeft, setShowFadeLeft] = useState(false)
  const [showFadeRight, setShowFadeRight] = useState(false)
  const { route } = useAppContext()

  const handleScroll = () => {
    const width = scrollRef.current.scrollWidth
    const { scrollLeft } = scrollRef.current
    setShowFadeLeft(scrollLeft >= FADE_TRIGGER)
    setShowFadeRight(scrollLeft <= width - window.innerWidth - FADE_TRIGGER)
  }

  const getengagementDestination = breadcrumbType => {
    if (!breadcrumbType) {
      if (route === 'reviews_listing') {
        return 'go-to_product_reviews'
      }

      if (route === 'serp_fulltext' || route === 'serp_fulltext_software') {
        return 'go-to_serp_fulltext'
      }
    }
    if (breadcrumbType === 'category' || route === 'serp_category') {
      return 'go-to_category_all-products'
    }
    return 'go-to_product_details'
  }

  useEffect(() => {
    const handleAutoScroll = () => {
      const width = scrollRef.current.scrollWidth
      scrollRef.current.scrollLeft = width
      setShowFadeLeft(true)
      setShowFadeRight(false)
      handleScroll()
    }
    handleAutoScroll()
    window.addEventListener('resize', handleAutoScroll)
    return () => {
      window.removeEventListener('resize', handleAutoScroll)
    }
  }, [scrollRef])

  useEffect(() => {
    handleScroll()
  }, [breadcrumbs, scrollRef])

  const breadcrumbStructuredItems = useMemo(
    () =>
      breadcrumbs.map(({ label, url }) => ({
        name: label,
        path: url,
      })),
    [breadcrumbs]
  )

  return (
    <div className={clsx('BreadcrumbBar', classes.overflowContainer)}>
      <div className={clsx(classes.fade, classes.fadeLeft, { [classes.fadeOn]: showFadeLeft })} />
      <Container className={classes.container} ref={scrollRef} onScroll={handleScroll}>
        {!!breadcrumbs.length && (
          <Breadcrumb className={classes.breadcrumb} structuredDataItems={breadcrumbStructuredItems}>
            {breadcrumbs.map((item, index) => {
              const isLast = index === breadcrumbs.length - 1
              return (
                <Breadcrumb.Item
                  key={`${item.label}-${item.url || 'current'}`}
                  isDisabled={isLast}
                  action={getengagementDestination(item.type)}
                  href={item.url}
                  className={clsx(classes.breadcrumbItem, isLast ? classes.breadcrumbLabel : classes.breadcrumbLink)}
                >
                  {item.label}
                </Breadcrumb.Item>
              )
            })}
          </Breadcrumb>
        )}
      </Container>
      <div className={clsx(classes.fade, classes.fadeRight, { [classes.fadeOn]: showFadeRight })} />
    </div>
  )
}

export default BreadcrumbBar
